import { Tooltip } from 'antd';
import Avatar from 'antd/lib/avatar/avatar';
import DefaultAvatar from 'components/common/DefaultAvatar';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import moment from 'moment';
import React from 'react';
import { IMessage } from 'types/messages';
import { IUser } from 'types/user';
import { fastGetDefaultAvatarUrl } from 'utils';

const ChatCard: React.FC<{ message: IMessage; isMessageSending?: boolean }> = ({ message, isMessageSending }) => {
  const userId = useCurrentLoggedInUser().id;
  const isSender = message.from?.id === userId;
  const sender = message.from;

  return (
    <div className=''>
      <div className={`flex items-center chatbox-single ${isSender ? 'sender' : 'receiver'}`}>
        {!isSender && !!sender && (
          <div className='p-1'>
            <Tooltip placement='left' title={`${sender.firstName} ${sender.lastName}`}>
              <Avatar src={fastGetDefaultAvatarUrl(sender as IUser)} />
            </Tooltip>
          </div>
        )}
        <Tooltip placement={isSender ? 'left' : 'right'} title={moment(message.createdAt).fromNow()}>
          <div className='text-message'>{message.message}</div>
        </Tooltip>
        {isMessageSending && (
          <div className='ml-2 '>
            <DefaultAvatar size={10} bgColor='transparent' borderColor='#038fde' />
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatCard;
